import { Reveal } from "@/components/Reveal";

const STATS = [
  { num: "0", label: "Renta mensual", sub: "Sin contrato de arrendamiento ni obligación de metros cuadrados." },
  { num: "$0", label: "Inventario físico", sub: "No inmoviliza capital en stock que se deprecia." },
  { num: "3", label: "Frentes cubiertos", sub: "Tecnología, adquisición de demanda y soporte, centralizados." },
];

export function ROI() {
  return (
    <section id="roi" data-testid="roi-section" className="relative py-24 sm:py-32 bg-crimson overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-crimson via-crimson to-crimson-dark" />
      <div className="absolute -bottom-40 -left-40 w-[36rem] h-[36rem] rounded-full bg-ivory/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <span className="font-sans text-xs uppercase tracking-[0.25em] text-ivory font-bold">Números y proyección</span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-ivory mt-6 leading-[1.05]">
            Menos costo fijo. Más de la inversión trabajando.
          </h2>
          <p className="font-sans text-lg font-light text-ivory/85 mt-6">
            Al eliminar el local, el inventario y la nómina de piso, una porción mucho mayor
            de su capital se destina a lo único que genera ingreso: adquirir y atender clientes.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-px bg-ivory/15 mt-16 border border-ivory/15">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className="bg-crimson-dark/40">
              <div className="p-10">
                <div className="font-serif text-6xl lg:text-7xl font-black text-ivory tracking-tighter">{s.num}</div>
                <div className="font-sans text-sm uppercase tracking-wider text-ivory font-semibold mt-4">{s.label}</div>
                <p className="font-sans text-sm font-light text-ivory/80 mt-3 leading-relaxed">{s.sub}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12">
          <div className="border border-ivory/20 bg-midnight/20 backdrop-blur-sm p-8 lg:p-10 flex flex-col lg:flex-row lg:items-center gap-6 justify-between">
            <div>
              <div className="font-serif text-2xl font-bold text-ivory">Proyección personalizada por territorio</div>
              <p className="font-sans text-base font-light text-ivory/85 mt-2 max-w-2xl">
                Los rangos de retorno dependen del país, el territorio y el capital de trabajo asignado.
                En la llamada de precalificación compartimos los números concretos de su mercado.
              </p>
            </div>
            <button
              data-testid="roi-cta-button"
              onClick={() => document.getElementById("registro")?.scrollIntoView({ behavior: "smooth" })}
              className="bg-ivory text-crimson font-bold py-4 px-8 hover:bg-white transition-all uppercase tracking-wider text-sm shrink-0"
            >
              Solicitar mis números
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <p className="font-sans text-xs text-ivory/60 mt-6 max-w-3xl leading-relaxed">
            * Las cifras mostradas son ilustrativas del modelo de costos y no constituyen una promesa de
            rendimiento. Todo negocio implica riesgo; los resultados varían según la ejecución del franquiciatario.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
